import * as React from "react";

const SvgIcnSmsAlt = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M13 4a1 1 0 01.993.883L14 5v2.999L19 8a1 1 0 011 1v7a1 1 0 01-1 1h-9l-1.445.964A1 1 0 017 17.131V9a1 1 0 011-1l5-.001V5H5v14h8v-2h1v2a1 1 0 01-.883.993L13 20H5a1 1 0 01-.993-.883L4 19V5a1 1 0 01.883-.993L5 4h8zm0 4.999L8 9v8.131L9.697 16H19V9l-5-.001V9h-1v-.001zM14.5 13a.5.5 0 010 1h-4a.5.5 0 010-1h4zm2-2a.5.5 0 010 1h-6a.5.5 0 010-1h6zm-8-5a.5.5 0 010 1h-1a.5.5 0 010-1h1zm2 0a.5.5 0 110 1 .5.5 0 010-1z"
        />
    </svg>
);

export default SvgIcnSmsAlt;
